const GET_SUBCATEGORY_PRODUCTS = "GET_SUBCATEGORY_PRODUCTS";
const GET_SUBCATEGORY_PRODUCTS_SUCCESS = "GET_SUBCATEGORY_PRODUCTS_SUCCESS";
const GET_SUBCATEGORY_PRODUCTS_FAILURE = "GET_SUBCATEGORY_PRODUCTS_FAILURE";
const CLEAR_GET_SUBCATEGORY_PRODUCTS = "CLEAR_GET_SUBCATEGORY_PRODUCTS";
const SET_SUBCATEGORY_PAGE = "SET_SUBCATEGORY_PAGE";

const subcategoryProductsSymbols = {
  GET_SUBCATEGORY_PRODUCTS_SUCCESS,
  GET_SUBCATEGORY_PRODUCTS_FAILURE,
  GET_SUBCATEGORY_PRODUCTS,
  CLEAR_GET_SUBCATEGORY_PRODUCTS,
  SET_SUBCATEGORY_PAGE,
};
export default subcategoryProductsSymbols;
